export enum OperationType {
 OP = 1,
 UG = 2
}